import template from './backButton.template.html';

/* @ngInject */

export default ($window) => ({
  template,
  restrict: 'E',
  scope: {
    back: '@'
  },
  link: (scope, elem) => {
    elem.bind('click', () => {
      $window.history.back();
    });
  }
});
